// extracted by mini-css-extract-plugin
export var alt = "BrandTeasers-module--alt--7c211";
export var brandTeaserContainer = "BrandTeasers-module--brandTeaserContainer--dbd6e";
export var cards = "BrandTeasers-module--cards--c06cb";
export var cardsItem = "BrandTeasers-module--cardsItem--eb6f1";
export var description = "BrandTeasers-module--description--c095f";
export var desktopOnly = "BrandTeasers-module--desktopOnly--e8ca5";
export var main = "BrandTeasers-module--main--9964a";
export var mobileOnly = "BrandTeasers-module--mobileOnly--456d7";
export var textLeft = "BrandTeasers-module--textLeft--f6794";
export var title = "BrandTeasers-module--title--e662d";
export var visuallyHidden = "BrandTeasers-module--visuallyHidden--a89d4";